import {
  createTopJobLabel,
  createQuestionQhrase,
  createAnswerQhrase,
} from '@doda/common/src/logics/JobContent/JobTrend/createFaqQhrase';

/**
 * FAQ構造化データ作成
 * @param {string} targetName ページの一軸名
 * @param {(string[] | number[])[]} rankingList 棒グラフ用配列(requirementsなどで指定したものを渡す)
 * @param {string} categoryFlg こだわりフラグ名
 * @returns JSON
 */
export const createFaqLd = (
  targetName: string,
  rankingList: (string[] | number[])[],
  categoryFlg: string
) => {
  // 求人数が最も多い項目名を取得
  const jobLabel = createTopJobLabel(rankingList, categoryFlg);

  return {
    '@type': 'Question',
    name: createQuestionQhrase(targetName, categoryFlg),
    acceptedAnswer: {
      '@type': 'Answer',
      text: createAnswerQhrase(jobLabel, categoryFlg),
    },
  };
};
